import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import './VehicleDetails.css';
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import Calculator from './Calculator';
//import calculatorDemo from "./assets/calculatorDemo.jpg";

const VehicleDetails = () => {
    const { carId } = useParams();
    const [carDetails, setCarDetails] = useState(null);
    const [carImages, setCarImages] = useState([]);
    const [mainImageIndex, setMainImageIndex] = useState(0);
    const [thumbnailIndex, setThumbnailIndex] = useState(0);
    const [touchStartX, setTouchStartX] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [dragStartX, setDragStartX] = useState(0);

    useEffect(() => {
        fetch(`https://skcapi.btcjapan.co/get-car-details-with-images.php?id=${carId}`)
            .then(response => response.json())
            .then(data => {
                setCarDetails(data.carDetails);
                setCarImages([data.carDetails.images, ...data.carImages.map(img => img.image_path)]);
            })
            .catch(error => {
                console.error("Error fetching car details:", error);
            });
    }, [carId]);

    const handleThumbnailClick = (index) => {
        setMainImageIndex(index);
    };

    const handleArrowClick = (direction) => {
        if (direction === 'left') {
            setMainImageIndex((prevIndex) => (prevIndex === 0 ? carImages.length - 1 : prevIndex - 1));
        } else if (direction === 'right') {
            setMainImageIndex((prevIndex) => (prevIndex === carImages.length - 1 ? 0 : prevIndex + 1));
        }
    };

    const handleThumbnailArrowClick = (direction) => {
        if (direction === 'left') {
            setThumbnailIndex((prevIndex) => (prevIndex === 0 ? carImages.length - 1 : prevIndex - 1));
        } else if (direction === 'right') {
            setThumbnailIndex((prevIndex) => (prevIndex === carImages.length - 1 ? 0 : prevIndex + 1));
        }
    };

    const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        if (touchStartX === 0) return;

        const touchEndX = e.touches[0].clientX;
        const deltaX = touchStartX - touchEndX;

        if (deltaX > 50) {
            handleArrowClick('right');
            setTouchStartX(0);
        } else if (deltaX < -50) {
            handleArrowClick('left');
            setTouchStartX(0);
        }
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setDragStartX(e.clientX);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;

        const dragEndX = e.clientX;
        const deltaX = dragStartX - dragEndX;

        if (deltaX > 50) {
            handleArrowClick('right');
            setIsDragging(false);
        } else if (deltaX < -50) {
            handleArrowClick('left');
            setIsDragging(false);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    if (!carDetails) {
        return <div>Loading...</div>;
    }

    const requiredFeatures = [
        "abs",
        "airbag",
        "bluetooth",
        "cdPlayer",
        "dvd",
        "tv",
        "powerSteering",
        "powerWindow",
        "sunRoof",
        "leatherSeat",
        "alloyWheels",
        "ac",
        "radio",
        "caChanger",
        "powerSeat",
        "backTire",
        "grillGuard",
        "rearSpoiller",
        "centralLock",
        "jack",
        "spareTire",
        "wheelSpanner",
        "fogLights",
        "backCamera",
        "pushStart",
        "keylessEntry",
        "esc",
        "cam360deg",
        "bodyKit",
        "sideAirbag",
        "powerMirror",
        "sideSkirts",
        "frontLip",
        "navigation",
        "turbo",
        "powerDoor",
    ];

    const features = JSON.parse(carDetails.features || "{}");

    // Merge required features with database features
    const allFeatures = requiredFeatures.reduce((acc, feature) => {
        acc[feature] = features[feature] || false; // Default to false if feature is not in the database
        return acc;
    }, {});

    /*    
        const featureNames = Object.keys(allFeatures);
    
        const chunkArray = (array, size) => {
            const result = [];
            for (let i = 0; i < array.length; i += size) {
                result.push(array.slice(i, i + size));
            }
            return result;
        };
    
        const featureRows = chunkArray(featureNames, 4);
    */

    // Show only available features (value === true)    
    const availableFeatureNames = Object.keys(allFeatures).filter(key => allFeatures[key]);

    const chunkArray = (array, size) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };

    const featureRows = chunkArray(availableFeatureNames, 4);

    return (
        <>
            <div className="row">
                <div className="col-2 leftcol">
                    <LeftSection />
                </div>
                <div className="col-8 middlecol">
                    <div className="details-container my-4">

                        <div className="row">

                            <div className="col-sm image-col">
                                <div className="main-image-container">
                                    <img
                                        src={`https://skcapi.btcjapan.co/${carImages[mainImageIndex]}`}
                                        alt={carDetails.model}
                                        className="img-fluid main-image"
                                        onTouchStart={(e) => handleTouchStart(e)}
                                        onTouchMove={(e) => handleTouchMove(e)}
                                        onMouseDown={(e) => handleMouseDown(e)}
                                        onMouseMove={(e) => handleMouseMove(e)}
                                        onMouseUp={handleMouseUp}
                                        onMouseLeave={handleMouseUp}
                                    />
                                    <div className="arrow left-arrow" onClick={() => handleArrowClick('left')}>&#10094;</div>
                                    <div className="arrow right-arrow" onClick={() => handleArrowClick('right')}>&#10095;</div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <div className="thumbnail-container">
                                            <div className="thumbnail-arrow left-arrow" onClick={() => handleThumbnailArrowClick('left')}>&#10094;</div>
                                            <div className="thumbnail-arrow right-arrow" onClick={() => handleThumbnailArrowClick('right')}>&#10095;</div>
                                            <div className="thumbnail-vehicle-details" style={{ transform: `translateX(-${thumbnailIndex * 110}px)` }}>
                                                {carImages.map((image, index) => (
                                                    <img
                                                        key={index}
                                                        src={`https://skcapi.btcjapan.co/${image}`}
                                                        alt={`${carDetails.model} ${index}`}
                                                        className={`thumbnail ${index === mainImageIndex ? 'active' : ''}`}
                                                        onClick={() => handleThumbnailClick(index)}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="col-sm calculator-col">
                                <Calculator />
                            </div>

                            <div className="col-sm details-col">

                                <div className="specs-table">
                                    <strong>Specification:</strong>
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th>Maker</th>
                                                <td>{carDetails.maker}</td>
                                                <th>Model</th>
                                                <td>{carDetails.model}</td>
                                            </tr>
                                            <tr>
                                                <th>Year</th>
                                                <td>{carDetails.year}</td>
                                                <th>Mileage</th>
                                                <td>{carDetails.mileage} km</td>

                                            </tr>
                                            <tr>
                                                <th>Price</th>
                                                <td>$ {carDetails.price}</td>
                                                <th>Engine</th>
                                                <td>{carDetails.engine}</td>
                                            </tr>
                                            <tr>
                                                <th>Steering</th>
                                                <td>{carDetails.steering}</td>
                                                <th>Transmission</th>
                                                <td>{carDetails.transmission}</td>
                                            </tr>
                                            <tr>
                                                <th>Fuel</th>
                                                <td>{carDetails.fuel}</td>
                                                <th>Drive</th>
                                                <td>{carDetails.drive}</td>
                                            </tr>
                                            <tr>
                                                <th>Doors</th>
                                                <td>{carDetails.doors}</td>
                                                <th>Chassis</th>
                                                <td>{carDetails.vin}</td>
                                            </tr>
                                            <tr>
                                                <th>Interior Color</th>
                                                <td>{carDetails.color}</td>
                                                <th>Exterior Color</th>
                                                <td>{carDetails.weight}</td>
                                            </tr>
                                            <tr>
                                                <th>Location</th>
                                                <td>{carDetails.location}</td>
                                                <th>Seats</th>
                                                <td>{carDetails.seats}</td>
                                            </tr>
                                            <tr>
                                                <th>Country</th>
                                                <td>{carDetails.country}</td>
                                                <th>Stock ID</th>
                                                <td>{carDetails.stock_id}</td>
                                            </tr>
                                            <tr>
                                                <th>Body Type</th>
                                                <td>{carDetails.body_type}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="features-section">
                                    <strong>Features:</strong>
                                    <div className="table-responsive">
                                        <table className="table table-bordered mt-3">
                                            <tbody>
                                                {featureRows.map((row, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        {row.map((feature, colIndex) => (
                                                            <td
                                                                key={colIndex}
                                                                style={{
                                                                    backgroundColor: allFeatures[feature] ? '#FAE690' : '#F4F4F4',
                                                                    border: `1px solid ${allFeatures[feature] ? '#000000' : '#ddd'}`,
                                                                    margin: '5px',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                <div className="feature-label">
                                                                    {feature}
                                                                </div>
                                                            </td>
                                                        ))}
                                                        {/* Fill empty cells if the last row has less than 4 features */}
                                                        {row.length < 4 && Array(4 - row.length).fill().map((_, index) => (
                                                            <td key={`empty-${index}`}></td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                            
                        </div>

                    </div>
                </div>

                <div className="col-2 rightcol">
                    <RightSection />
                </div>
            </div>
        </>
    );
};

export default VehicleDetails;